import { BarList, BarListData, useChart } from '@chakra-ui/charts';
import { Flex, Heading, Stack, Stat } from '@chakra-ui/react';
import pluralize from 'pluralize';
import { memo } from 'react';

const TopLocations = () => {
  const chart = useChart<BarListData>({
    sort: { by: 'value', direction: 'desc' },
    data: [
      {
        name: 'Airport Residential Area',
        value: 10,
      },
      {
        name: 'East Legon',
        value: 20,
      },
      {
        name: 'Tema',
        value: 2,
      },
    ],
    series: [{ name: 'name', color: 'teal.subtle' }],
  });

  return (
    <Flex bg="surface.background" borderRadius="md" boxShadow="md" flexDir="column" gap={2} p={2}>
      <Heading size="sm">Top Locations</Heading>
      <BarList.Root chart={chart} w="full">
        <BarList.Content>
          <BarList.Bar cursor="pointer" />
          <BarList.Value valueFormatter={(value) => `${value} ${pluralize('rental', value)}`} />
        </BarList.Content>
      </BarList.Root>
    </Flex>
  );
};

const LiveStats = () => {
  return (
    <Stack width={{ base: 'md', mdDown: 'auto' }}>
      <Flex gap={2} pointerEvents="auto">
        <Stat.Root bg="surface.background" p={2} borderRadius="md" boxShadow="md" cursor="default">
          <Stat.Label fontSize="xs">Rentals right now</Stat.Label>
          <Stat.ValueText>10</Stat.ValueText>
        </Stat.Root>
        <Stat.Root bg="surface.background" p={2} borderRadius="md" boxShadow="md" cursor="default">
          <Stat.Label fontSize="xs">Total sales</Stat.Label>
          <Stat.ValueText>GHS800</Stat.ValueText>
        </Stat.Root>
      </Flex>
      <TopLocations />
    </Stack>
  );
};

export default memo(LiveStats);
